import { render } from "./IncomesTSBodySk.vue?vue&type=template&id=ba60cd0a&scoped=true"
import script from "./IncomesTSBodySk.vue?vue&type=script&lang=js"
export * from "./IncomesTSBodySk.vue?vue&type=script&lang=js"

import "./IncomesBodyStyle.css?vue&type=style&index=0&id=ba60cd0a&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba60cd0a"]])

export default __exports__